/* eslint-disable import/order */
import { classicBusinessProjectFormSubmitPublicRoute } from '@jira/router-routes__business-form-routes/src/classicBusinessProjectFormSubmitPublicRoute.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { formSubmitPageEntrypoint } from './ui/form-submit-public/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const classicBusinessProjectFormSubmitPublicRouteEntry: Route = createEntry(
	classicBusinessProjectFormSubmitPublicRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.form-submit-public-view',
		layout: chromelessLayout,
		resources: [...jiraSpaResources()],

		// This public route should not include
		// DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
		// remove all usages of projectKey.
		entryPoint: () => formSubmitPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
